exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".locationSVG{height:100%;visibility:hidden}.loader-text,.locationSVG{position:absolute;width:100%}.loader-text{top:70%;display:flex;justify-content:center}", ""]);

// exports
